import { forwardRef } from "react";
import Input from "@/atoms/Input";

const InputField = forwardRef(
  ({ id, name, label, required, desc, className, ...props }, ref) => {
    const inputId = id || name;

    return (
      <div className={`awd-input-wrapper ${className}`}>
        <Input id={inputId} ref={ref} placeholder={label} {...props} />
        <label className="awd-input-label" htmlFor={inputId}>
          {label}
          <span className="awd-input-required">{required && " *"}</span>
        </label>
        {desc && <span className="awd-input-desc">{desc}</span>}
      </div>
    );
  }
);

export default InputField;
